export default "__VITE_ASSET___PM97JVp__"